module.exports = __webpack_public_path__ + "img/facebook.d6a9fd43.svg";